import React, { ReactElement } from 'react'
import { BigListTeaserImage } from '../HelperClass'

type BigListTeaserArticleImageProps = {
    /** url of the main image */
    mainImageUrl?: string
    /** info for seo about mainImageUrl */
    mainImageAlt?: string
}
const BigListTeaserArticleImage = ({
    mainImageUrl,
    mainImageAlt,
}: BigListTeaserArticleImageProps): ReactElement => {
    return <BigListTeaserImage mainImageUrl={mainImageUrl} mainImageAlt={mainImageAlt} />
}

export default BigListTeaserArticleImage
